export const StatesMassivePayments = {
  CREATED: "CREATED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  PARTIAL: "PARTIAL",
};

export const getTagType = (state) => {
  switch (state) {
    case StatesMassivePayments.CREATED:
      return "info";
    case StatesMassivePayments.PROCESSING:
      return "warning";
    case StatesMassivePayments.COMPLETED:
      return "success";
    case StatesMassivePayments.FAILED:
      return "error";
    case StatesMassivePayments.PARTIAL:
      return "normal";
  }
};

const STABLECOINS = ["USDT", "USDC"];

/**
 * Espejo de resolveCryptoFee() de apiPortal (src/utils/cryptoFee.js), que es
 * la fuente de verdad: lo que se muestra aca tiene que ser lo que el backend
 * descuenta.
 *
 * Antes esta pantalla mostraba `monto x comision_crypto_out / 100`. Ese campo
 * quedo en 0 al reemplazarse por el modelo de tres modos, asi que mostraba
 * "Fee 0.00" mientras el backend descontaba: el usuario veia un numero y
 * recibia otro.
 *
 * Los tres modos que se pueden resolver aca dan el monto EXACTO. El unico que
 * no es DYNAMIC sobre token nativo, porque depende del costo de red estimado
 * en el momento del envio: para ese devuelve `unknown` y la UI lo dice, en vez
 * de inventar una cifra.
 *
 * @returns {{ amount: number|null, unknown: boolean, label: string }}
 */
export const resolveDisplayFee = ({ feeConfig, coin, amount }) => {
  const cfg = feeConfig || {};
  const mode = cfg.crypto_fee_mode || "OFF";
  const isStable = STABLECOINS.includes(coin);
  const none = { amount: 0, unknown: false, label: "0.00" };

  if (mode === "OFF") return none;

  if (mode === "FIXED") {
    const raw = isStable ? cfg.crypto_fee_fixed_usd : cfg.crypto_fee_fixed_native;
    const fee = Number(raw) || 0;
    return { amount: fee, unknown: false, label: String(fee) };
  }

  if (mode === "DYNAMIC") {
    // Sobre stablecoin el backend cae al monto fijo en USD, porque cobrar el
    // gas equivalente requiere una cotizacion que el sistema no tiene.
    if (isStable) {
      const fee = Number(cfg.crypto_fee_fixed_usd) || 0;
      return { amount: fee, unknown: false, label: String(fee) };
    }
    // Sobre token nativo depende del gas del momento. No se estima aca.
    return { amount: null, unknown: true, label: "calculated on send" };
  }

  return none;
};

/** Monto que efectivamente recibe el destinatario. */
export const getNetAmount = (amount, fee) => {
  const a = Number(amount);
  if (isNaN(a) || fee == null) return null;
  return Math.round((a - fee) * 1e6) / 1e6;
};
